import { render, staticRenderFns } from "./ViewPlotDetails700.vue?vue&type=template&id=edc8df3a"
import script from "./ViewPlotDetails700.vue?vue&type=script&lang=ts"
export * from "./ViewPlotDetails700.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports